import React from 'react'
import { useNavigate } from 'react-router-dom';
import './ProductList.css';

function ProductList({products}) {

    const navigate = useNavigate();


    return (
        <div className="product-grid">
            {products.map(product => (
                <div 
                    key={product._id}
                    className="product-card"
                    onClick={() => navigate(`/product/${product._id}`)}
                >
                    <div className="product-image-container">
                        {product.images && product.images.length > 0 && (
                            <img 
                                src={`http://localhost:3001/uploads/${product.images[0]}`}
                                alt={product.description}
                                className="product-image"
                            />
                        )}
                    </div>
                    <div className="product-details">
                        <h3 className="product-brand">{product.brand}</h3>
                        <p className="product-type">{product.productType}</p>
                        <div className="product-price-container">
                            <span className="current-price">₹{product.price.discounted || product.price.actual}</span>
                            {product.price.discounted && (
                                <span className="original-price">₹{product.price.actual}</span>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default ProductList